import { UserEntitiesResponse } from "@common/types/entityContext";
import {
    UserEntitiesWireResponse,
    userEntitiesResponseSchema,
} from "@common/schemas/domains/entity/entity-context-response.schema";

export function parseUserEntitiesResponse(
    body: UserEntitiesWireResponse,
): UserEntitiesResponse {
    const { entities } = userEntitiesResponseSchema.parse(body);
    return {
        entities: entities.map((context) => ({
            ...context,
            financialAccounts: context.financialAccounts.map(
                ({ integrationAccounts, ...account }) => {
                    const financialAccount = {
                        ...account,
                        entity: context.entity,
                    };
                    return {
                        ...financialAccount,
                        integrationAccounts: integrationAccounts.map(
                            (integrationAccount) => ({
                                ...integrationAccount,
                                financialAccount,
                            }),
                        ),
                    };
                },
            ),
        })),
    };
}
